import React from 'react';
import Imgix from 'react-imgix';
import styled from 'styled-components';
import { FilterButton } from '../../../../../styles/theme/default/buttons';
import { BodyThree } from '../../../../../styles/theme/default/typography';

const Wrapper = styled.div`
  margin-top: 30px;

  .colors-filters-container {
    margin: 10px 0px 25px 0;
  }

  .multi-color-image {
    margin-right: 6px;
    width: 16px;
    height: auto;
  }

  .white-dot {
    border: 1px solid #d8d8d8;
  }
`;

const order = [
  'Red',
  'Pink',
  'Orange',
  'Yellow',
  'Green',
  'Teal',
  'Blue',
  'Navy',
  'Purple',
  'Grey',
  'Black',
  'Brown',
  'White',
  'Neutral'
];

const sortColors = colorsArr => {
  const sortedColors = [...colorsArr].sort((a, b) => {
    const aIndex = order.indexOf(a.name);
    const bIndex = order.indexOf(b.name);

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }

    if (aIndex !== -1) {
      return -1;
    }

    if (bIndex !== -1) {
      return 1;
    }

    return 0;
  });

  const multiIdx = sortedColors.findIndex(color => color.name === 'Multi');
  let multi = [];

  if (multiIdx !== -1) {
    multi = sortedColors.splice(multiIdx, 1);
    sortedColors.push(...multi);
  }

  return sortedColors;
};

function FilterColor({ colors, colorIds, setColorIds }) {
  const handleClick = colorId => {
    const isSelected = colorIds.some(id => id === parseInt(colorId));
    if (isSelected) {
      setColorIds(colorIds.filter(id => id !== parseInt(colorId)));
    } else {
      setColorIds([...colorIds, parseInt(colorId)]);
    }
  };

  if (colors?.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <BodyThree>Color</BodyThree>{' '}
      <div className="colors-filters-container">
        {sortColors([...colors]).map(color => {
          return (
            <FilterButton
              key={color.id}
              title={color.name}
              className="ais-RefinementList-item"
              color={color.hex_code}
              selected={colorIds.some(id => id === parseInt(color.id))}
              onClick={() => handleClick(color.id)}
            >
              {setColorDot(color.hex_code)}
              {color.name}
            </FilterButton>
          );
        })}
      </div>
    </Wrapper>
  );
}

export default FilterColor;

const setColorDot = hexCode => {
  if (hexCode === '') {
    return (
      <Imgix
        className={`multi-color-image`}
        sizes="15px"
        imgixParams={{ auto: 'compress,format' }}
        src={'https://theinside.imgix.net/icons/color-wheel-icon.svg'}
        htmlAttributes={{
          alt: 'Multi Color'
        }}
      />
    );
  } else {
    return (
      <ColorDot
        className={hexCode == '#FFFFFF' ? 'white-dot' : ''}
        color={hexCode}
      />
    );
  }
};

export const ColorDot = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  background-color: ${props => props.color};
`;
